var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('div',{staticClass:"outer",attrs:{"id":_vm.ID_JSS_LAYOUT_DEFAULT}},[_c('div',{ref:"page",staticClass:"page",attrs:{"tabindex":"-1"}},[_vm._t("default",[_c('nuxt')])],2),_vm._v(" "),_c('critical-error-modal')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }